import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wagers-container" }
const _hoisted_2 = { class: "wagers-card desktop-only" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "wagers-table" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  colspan: "8",
  class: "loader-cell"
}
const _hoisted_7 = { class: "table-loader" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  colspan: "8",
  class: "empty-cell"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "mobile-cards mobile-only" }
const _hoisted_12 = {
  key: 0,
  class: "loading-cards"
}
const _hoisted_13 = { class: "card-loader" }
const _hoisted_14 = {
  key: 1,
  class: "empty-cards"
}

import { computed } from 'vue'
import type { Transaction } from '@/stores/transactions'
import WagerCard from './WagerCard.vue'
import { formatCurrency } from '@/utils/currency'

import { useI18n } from 'vue-i18n'

export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionsTable',
  props: {
    transactions: {},
    loading: { type: Boolean }
  },
  emits: ["view-details", "rebet"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const tableRows = computed(() => {
  return props.transactions
})

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

const handleRebet = () => {
  emit('rebet')
}

const { t } = useI18n()

const getTotalReturn = (item: Transaction) => {
  if (item.bet_status.toLowerCase() === 'open') {
    return t('wagers.tbc')
  }
  return formatCurrency(item.total_winnings, item.currency_symbol)
}

const getStatusClass = (item: Transaction) => {
  if (item.bet_status.toLowerCase() === 'settled' && item.total_winnings === '0.00') {
    return 'settled-zero'
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.betslipId')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.date')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.reference')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.description')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.status')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.totalBetAmount')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.totalReturn')), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t('wagers.detailsText')), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "spinner" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('wagers.loadingTransactions')), 1)
                    ])
                  ])
                ]))
              : (tableRows.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.$t('wagers.noTransactions')), 1)
                  ]))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(tableRows.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: "transaction-row"
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, _toDisplayString(formatDate(item.created_at)), 1),
                      _createElementVNode("td", null, _toDisplayString(item.reference), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t('wagers.wager')), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['status', item.bet_status.toLowerCase(), getStatusClass(item)])
                        }, _toDisplayString(item.bet_status), 3)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.currency_symbol) + " " + _toDisplayString(item.total), 1),
                      _createElementVNode("td", null, _toDisplayString(getTotalReturn(item)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "details-button",
                          onClick: _withModifiers(($event: any) => (_ctx.$emit('view-details', item)), ["stop"])
                        }, _toDisplayString(_ctx.$t('wagers.detailsText')), 9, _hoisted_10)
                      ])
                    ]))
                  }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "spinner" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('wagers.loadingTransactions')), 1)
            ])
          ]))
        : (tableRows.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('wagers.noTransactions')), 1)
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(tableRows.value, (item) => {
              return (_openBlock(), _createBlock(WagerCard, {
                key: item.id,
                transaction: item,
                onViewDetails: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('view-details', $event))),
                onRebet: handleRebet
              }, null, 8, ["transaction"]))
            }), 128))
    ])
  ]))
}
}

})